import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  public recaptchaSiteKey: string = '6LfPm7kUAAAAAMTZT8KzrIfdmdaEPiwchQZIhYmx';
}
